import { getFirestore, doc, onSnapshot, setDoc, serverTimestamp } from "firebase/firestore";
import { app } from "../../config/config";
import { REF } from "../ref";
import { TYPES } from "./payout_setting.type";

const firestore = getFirestore(app);

let holidaysSub = null;
let afterHoursSub = null;
let generalSub = null;

// -------------------------- Holidays --------------------------
export const snapHolidays =
  ({ year }, callback) =>
  (dispatch) => {
    if (holidaysSub) {
      holidaysSub();
      holidaysSub = null;
    }
    dispatch({ type: TYPES.GET_HOLIDAYS_REQUEST });
    const dRef = doc(firestore, REF.PAYOUT_SETTING, `holidays${year}`);
    holidaysSub = onSnapshot(dRef, (snap) => {
      const data = snap.exists() ? snap.data()?.holidays || [] : [];
      dispatch({ type: TYPES.GET_HOLIDAYS_SUCCESS, payload: { year, data } });
      if (callback) callback(data);
    });
  };

export const unSnapHolidays = () => () => {
  if (holidaysSub) {
    holidaysSub();
    holidaysSub = null;
  }
};

export const saveHolidays =
  ({ year, holidays }) =>
  (dispatch) => {
    dispatch({ type: TYPES.SAVE_HOLIDAYS_SUCCESS, payload: { year, holidays } });
    const dRef = doc(firestore, REF.PAYOUT_SETTING, `holidays${year}`);
    setDoc(dRef, { holidays }, { merge: true });
  };

// -------------------------- After Hours --------------------------
export const snapAfterHours = (callback) => (dispatch) => {
  if (afterHoursSub) {
    afterHoursSub();
    afterHoursSub = null;
  }
  dispatch({ type: TYPES.GET_AFTER_HOURS_REQUEST });
  const dRef = doc(firestore, REF.PAYOUT_SETTING, "afterHours");
  afterHoursSub = onSnapshot(dRef, (snap) => {
    const data = snap.exists() ? snap.data()?.branches || {} : {};
    dispatch({ type: TYPES.GET_AFTER_HOURS_SUCCESS, payload: data });
    if (callback) callback(data);
  });
};

export const unSnapAfterHours = () => () => {
  if (afterHoursSub) {
    afterHoursSub();
    afterHoursSub = null;
  }
};

export const saveAfterHours =
  ({ branches }, callback) =>
  (dispatch) => {
    dispatch({ type: TYPES.SAVE_AFTER_HOURS_SUCCESS, payload: branches });
    const dRef = doc(firestore, REF.PAYOUT_SETTING, "afterHours");
    setDoc(dRef, { branches }, { merge: true }).then(() => {
      if (callback) callback();
    });
  };

// -------------------------- General --------------------------
export const snapGeneral = (callback) => (dispatch) => {
  if (generalSub) {
    generalSub();
    generalSub = null;
  }
  dispatch({ type: TYPES.GET_GENERAL_REQUEST });
  const dRef = doc(firestore, REF.PAYOUT_SETTING, "general");
  generalSub = onSnapshot(dRef, (snap) => {
    const data = snap.exists() ? snap.data() : null;
    dispatch({ type: TYPES.GET_GENERAL_SUCCESS, payload: data });
    if (callback) callback(data);
  });
};

export const unSnapGeneral = () => () => {
  if (generalSub) {
    generalSub();
    generalSub = null;
  }
};

export const saveGeneral =
  ({ afterHourRate, holidayRate, roundingBaseInterval, roundingRules }, callback) =>
  (dispatch) => {
    const data = {
      afterHourRate,
      holidayRate,
      roundingBaseInterval,
      roundingRules,
      updatedAt: serverTimestamp(),
    };
    dispatch({ type: TYPES.SAVE_GENERAL_SUCCESS, payload: data });
    const dRef = doc(firestore, REF.PAYOUT_SETTING, "general");
    setDoc(dRef, data, { merge: true }).then(() => {
      if (callback) callback();
    });
  };
